import { fromNow } from '@btime/helpers'
import { pick } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { useOpenFormReplyModal } from '../../../utils/routes/modals/modalsActions'
import { useReplies } from './_load/RepliesLoader'
import DataTable from '../../../packages/kiti/components/table/DataTable'
import DynamicPresentation from '../../../containers/dynamic/DynamicPresentation'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Text, { SmallText } from '../../../packages/kiti/components/presentation/Text'

const RepliesTable = () => {
  const { t } = useTranslation(['common', 'replies'])
  const data = useReplies()
  const openFormReplyModal = useOpenFormReplyModal()

  const columns = [
    {
      label: t('replies:table.name'),
      headerSideContent: <RefetchingIndicator />,
      dataIndex: 'name',
      sortIndex: false,
      flex: 3,
      render: (_, record) => {
        let subtitle = `${t('replies:replyNumber')}${record.formReply?.number}`
        let title = record.formReply?.place?.name || record.serviceOrder?.user?.name
        if (!title) {
          title = subtitle
          subtitle = false
        }
        return (
          <>
            <SmallText hideIfEmpty size="xsmall">
              {subtitle}
            </SmallText>
            <Text bold>{title}</Text>
          </>
        )
      }
    },

    {
      label: t('replies:table.value'),
      dataIndex: 'value',
      sortIndex: false,
      flex: 2,
      render: (value, record) => <DynamicPresentation value={value} type={record.question?.type?.name} size="small" />
    },

    {
      label: t('replies:table.date'),
      dataIndex: 'insertedAt',
      flex: 1,
      format: fromNow
    },

    {
      label: t('actions'),
      flex: 1,
      render: (_, record) => (
        <IconText
          iconRight="BsArrowRightShort"
          size="xsmall"
          bold
          color="primary"
          label={t('replies:table.viewMore')}
          onClick={() => {
            openFormReplyModal(pick(['formId', 'number'], record.formReply || {}))
          }}
        />
      )
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" inPanel data={data} />
}

export default RepliesTable
